import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from 'react';
import { PageLoading } from 'components/atoms/loading';
import { lazyWithRetry } from 'utils/lazyWithRetry';
import { AccountActivatePage } from './account-activate';
import { AddApiKey, GoodbyePage, ImplicitCallback, LogoutPage } from './auth';
import { CpShareLinkPage } from './customer-portal/cp-share-page';
import { ForgotPasswordPage } from './forgot-password';
import { LinkActionPage } from './link-action';
import { MagicLinkPage } from './magic-link';
import { CustomerPortalMagicLink } from './magic-link/customer-portal-login';
import { MagicLinkGeneratePage } from './magic-link-generate';
import { ResetPasswordPage } from './reset-password';
import { ROUTE_PATHS } from './routes-paths';
import { SessionLogin } from './session-login';
import { SetupProfilePage } from './setup-profile';
const LazyLogin = lazyWithRetry(()=>import('routes/auth/login').then(({ Login })=>({
            default: Login
        })));
const LazyTwoFactAuthPage = lazyWithRetry(()=>import('components/pages/two-factor-auth').then((m)=>({
            default: m.TwoFactAuthPage
        })));
const LazyWebForm = lazyWithRetry(()=>import('./web-form').then(({ WebForm })=>({
            default: WebForm
        })));
export const nonProtectedRoutes = [
    {
        path: `${ROUTE_PATHS.IMPLICIT}/${ROUTE_PATHS.CALLBACK}`,
        element: /*#__PURE__*/ _jsx(ImplicitCallback, {})
    },
    {
        path: ROUTE_PATHS.LOGIN,
        element: /*#__PURE__*/ _jsx(LazyLogin, {})
    },
    {
        path: ROUTE_PATHS.MAGIC_LINK,
        element: /*#__PURE__*/ _jsx(MagicLinkPage, {})
    },
    {
        path: `${ROUTE_PATHS.CP}/${ROUTE_PATHS.SHARE}`,
        element: /*#__PURE__*/ _jsx(CpShareLinkPage, {})
    },
    {
        path: `${ROUTE_PATHS.CP}/${ROUTE_PATHS.EMBED}/*`,
        element: /*#__PURE__*/ _jsx(CustomerPortalMagicLink, {})
    },
    {
        path: `${ROUTE_PATHS.MAGIC_LINK}/${ROUTE_PATHS.NEW}`,
        element: /*#__PURE__*/ _jsx(MagicLinkGeneratePage, {})
    },
    {
        path: `${ROUTE_PATHS.MAGIC_LINK}/${ROUTE_PATHS.TWO_FA}`,
        element: /*#__PURE__*/ _jsx(Suspense, {
            fallback: /*#__PURE__*/ _jsx(PageLoading, {}),
            children: /*#__PURE__*/ _jsx(LazyTwoFactAuthPage, {})
        })
    },
    {
        path: `${ROUTE_PATHS.SETUP_PROFILE}`,
        element: /*#__PURE__*/ _jsx(SetupProfilePage, {})
    },
    {
        path: ROUTE_PATHS.FORGOT_PASSWORD,
        caseSensitive: true,
        element: /*#__PURE__*/ _jsx(ForgotPasswordPage, {})
    },
    {
        path: ROUTE_PATHS.RESET_PASSWORD,
        element: /*#__PURE__*/ _jsx(ResetPasswordPage, {})
    },
    {
        path: ROUTE_PATHS.LOGOUT,
        element: /*#__PURE__*/ _jsx(LogoutPage, {})
    },
    {
        path: ROUTE_PATHS.GOODBYE,
        element: /*#__PURE__*/ _jsx(GoodbyePage, {})
    },
    {
        path: ROUTE_PATHS.LINK_ACTION,
        element: /*#__PURE__*/ _jsx(LinkActionPage, {})
    },
    {
        path: ROUTE_PATHS.ACTIVATE,
        element: /*#__PURE__*/ _jsx(AccountActivatePage, {})
    },
    {
        path: ROUTE_PATHS.LOGIN_SESSION,
        element: /*#__PURE__*/ _jsx(SessionLogin, {})
    },
    {
        path: 'forms/:customerName/:instanceHash',
        element: /*#__PURE__*/ _jsx(LazyWebForm, {})
    },
    {
        path: 'add-api-key/:apiKey',
        element: /*#__PURE__*/ _jsx(AddApiKey, {})
    }
];
